// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1dn61","content":"styles_content__3WHO_","selectAll":"styles_selectAll__3ylz7"};